import store from '../store'

export default async (to, from, next) => {
  await store.dispatch('ui/ActionSetLoading', true)
  if (to.name != 'Login' && !store.getters['auth/GET_token']) {
    try {
      await store.dispatch('auth/ActionCheckToken')

      await Promise.all([
        store.dispatch('employees/ActionSetEmployees'),
        store.dispatch('utils/ActionSetUtils'),
        store.dispatch('employees/ActionSetScales'),
        store.dispatch('ci/ActionSetSendedIC'),
        store.dispatch('ci/ActionSetReceivedIC'),
        store.dispatch('ci/ActionSetAllIC'),
      ])

      document.title = `${to.meta.name} :: IPH - Sistemas`
      next({ name: to.name })
    } catch (error) {
      next({ name: 'Login' })
      document.title = `${to.meta.name} :: IPH - Sistemas`
    }
  } else {
    if (to.name == 'Login' && store.getters['auth/GET_token']) {
      next({ name: 'Home' })
      document.title = `${to.meta.name} :: IPH - Sistemas`
    } else if (to.name == 'Login' && !store.getters['auth/GET_token']) {
      next()
    } else {
      document.title = `${to.meta.name} :: IPH - Sistemas`
      store.dispatch('auth/ActionProfile')
      next()
    }
  }
  await store.dispatch('ui/ActionSetLoading', false)
}
